"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var styles_1 = require("../../utils/styles");
var Barcode_1 = __importDefault(require("../Barcode"));
var Div_1 = __importDefault(require("../Div"));
var Text_1 = __importDefault(require("../Text"));
var sok_1 = require("../../utils/chains/sok");
var Card_1 = __importDefault(require("./Card"));
var GridContainer_1 = __importDefault(require("./Grid/GridContainer"));
var GridItem_1 = __importDefault(require("./Grid/GridItem"));
var ItemTable_1 = __importDefault(require("./Item/ItemTable"));
var itemInformation_1 = require("./itemInformation");
var PriceTag_1 = __importDefault(require("./PriceTag"));
var ItemMainContentSok_1 = __importDefault(require("./Item/ItemMainContentSok"));
var priceItemsStyles = {
    singleGridItem: {
        margin: 'auto',
        width: '100%',
        height: '100%'
    },
    gridItem: {
        margin: 'auto'
    },
    itemHeader: {
        height: '35%'
    },
    itemHeaderWithTag: {
        height: '30%'
    },
    barcodeContainer: {
        float: 'left',
        position: 'absolute',
        bottom: 0,
        left: 0,
        margin: '10px 10px 10px 14px'
    },
    barcodeContainerSok: {
        float: 'left',
        position: 'absolute',
        bottom: 0,
        left: 0,
        margin: '10px 10px 20px 30px'
    }
};
var generateGridItemStyle = function (itemsCount) {
    return itemsCount === 1 ? priceItemsStyles.singleGridItem : priceItemsStyles.gridItem;
};
var generateScaleNumberStyles = function (styles, isImage) {
    if (isImage) {
        return styles;
    }
    return __assign(__assign({}, styles), { margin: '20px auto auto auto' });
};
var generateResponsiveTextStyles = function (styles, itemsCount) {
    var fontSize = styles.fontSize;
    if (fontSize) {
        var matches = fontSize.match(/\d+/);
        if (matches && matches.length > 0) {
            var fontSizeNumber = matches[0];
            if (itemsCount === 1) {
                return __assign(__assign({}, styles), { fontSize: "".concat(fontSizeNumber * 2, "px") });
            }
            else if (itemsCount > 1 && itemsCount < 5) {
                return __assign(__assign({}, styles), { fontSize: "".concat(fontSizeNumber * 1.2, "px") });
            }
        }
    }
    return styles;
};
var generateItemStyles = function (templateChildren, itemsCount) {
    var priceTagStyles = generateResponsiveTextStyles((0, styles_1.getTemplateChildrenStyles)(templateChildren, 0), itemsCount);
    var itemNameStyles = __assign({ position: 'relative' }, (0, styles_1.getTemplateChildrenStyles)(templateChildren, 1));
    var itemDescriptionStyles = __assign({ position: 'relative' }, (0, styles_1.getTemplateChildrenStyles)(templateChildren, 2));
    var itemImageStyles = (0, styles_1.getTemplateChildrenStyles)(templateChildren, 3);
    var itemPriceStyles = (0, styles_1.getTemplateChildrenStyles)(templateChildren, 4);
    var itemPriceUnitStyles = (0, styles_1.getTemplateChildrenStyles)(templateChildren, 5);
    return {
        priceTagStyles: priceTagStyles,
        itemNameStyles: itemNameStyles,
        itemDescriptionStyles: itemDescriptionStyles,
        itemImageStyles: itemImageStyles,
        itemPriceStyles: itemPriceStyles,
        itemPriceUnitStyles: itemPriceUnitStyles
    };
};
var generateMaxFontSizes = function (itemsCount) {
    if (itemsCount === 1) {
        return { descriptionMaxFontSize: 60 };
    }
    if (itemsCount === 2) {
        return { descriptionMaxFontSize: 50 };
    }
    if (itemsCount === 7 || itemsCount === 8) {
        return { descriptionMaxFontSize: 35 };
    }
    return { descriptionMaxFontSize: 40 };
};
var PriceItems = function (_a) {
    var templateChildren = _a.templateChildren, styles = _a.styles, items = _a.items, id = _a.id, chain = _a.chain;
    var itemsCount = items.length;
    var _b = generateItemStyles(templateChildren, itemsCount), priceTagStyles = _b.priceTagStyles, itemNameStyles = _b.itemNameStyles, itemDescriptionStyles = _b.itemDescriptionStyles, itemImageStyles = _b.itemImageStyles, itemPriceStyles = _b.itemPriceStyles, itemPriceUnitStyles = _b.itemPriceUnitStyles;
    var descriptionMaxFontSize = generateMaxFontSizes(itemsCount).descriptionMaxFontSize;
    return (react_1.default.createElement(GridContainer_1.default, { id: 'grid-container' }, items.map(function (product, i) {
        var _a, _b, _c;
        var productId = product.productId, name = product.name, imagePath = product.imagePath, tags = product.tags;
        var _d = (0, itemInformation_1.generateProductItemValues)(product), priceIntegers = _d.priceIntegers, priceDecimals = _d.priceDecimals, itemDescription = _d.itemDescription;
        var hasImage = imagePath !== null && imagePath !== undefined;
        var itemScaleNumberStyles = generateScaleNumberStyles((0, styles_1.getTemplateChildrenStyles)(templateChildren, 6), hasImage);
        var scaleNumberLabel = (0, styles_1.getTemplateChildrenLabel)(templateChildren, 6);
        var itemCardStyles = (0, styles_1.removeNullValues)(styles);
        // use sok components if chain === 'sok'
        var sokComponents = chain === 'sok'
            ? (0, sok_1.getSokComponents)({
                itemsCount: itemsCount,
                tags: tags,
                itemNameStyles: itemNameStyles,
                itemDescriptionStyles: itemDescriptionStyles,
                itemPriceStyles: itemPriceStyles,
                itemPriceUnitStyles: itemPriceUnitStyles,
                itemImageStyles: itemImageStyles,
                itemCardStyles: itemCardStyles,
                itemScaleNumberStyles: itemScaleNumberStyles
            })
            : undefined;
        return (react_1.default.createElement(GridItem_1.default, { key: "grid-item-".concat(i), id: 'grid-item', style: generateGridItemStyle(itemsCount) },
            react_1.default.createElement(Card_1.default, { itemsCount: itemsCount },
                react_1.default.createElement(Div_1.default, { key: "".concat(id, "-").concat(i), id: 'grid-item-custom-div', styles: ((_a = sokComponents === null || sokComponents === void 0 ? void 0 : sokComponents.customSokStyles) === null || _a === void 0 ? void 0 : _a.sokItemCardStyles) || itemCardStyles },
                    // use OLD discount price tag only for Kesko
                    chain !== 'sok' && (react_1.default.createElement(PriceTag_1.default, { styles: priceTagStyles, tags: tags, itemsCount: itemsCount })), sokComponents === null || sokComponents === void 0 ? void 0 :
                    sokComponents.SokTagSvg,
                    react_1.default.createElement("div", { id: 'item-header', style: (tags === null || tags === void 0 ? void 0 : tags.includes(seesignage_utils_1.ProductTags.discount))
                            ? priceItemsStyles.itemHeaderWithTag
                            : priceItemsStyles.itemHeader },
                        react_1.default.createElement(Text_1.default, { id: "".concat(id, "-").concat(i, "-name"), styles: ((_b = sokComponents === null || sokComponents === void 0 ? void 0 : sokComponents.customSokStyles) === null || _b === void 0 ? void 0 : _b.sokItemNameStyles) || itemNameStyles, value: name, textfit: { max: 120, mode: 'multi' } }),
                        itemDescription && (react_1.default.createElement(Text_1.default, { id: "".concat(id, "-").concat(i, "-description"), styles: ((_c = sokComponents === null || sokComponents === void 0 ? void 0 : sokComponents.customSokStyles) === null || _c === void 0 ? void 0 : _c.sokItemDescriptionStyles) ||
                                itemDescriptionStyles, value: itemDescription, textfit: { max: descriptionMaxFontSize, mode: 'multi' } }))),
                    (sokComponents === null || sokComponents === void 0 ? void 0 : sokComponents.customSokStyles) ? (react_1.default.createElement(ItemMainContentSok_1.default, { product: product, itemImageStyles: itemImageStyles, scaleNumberLabel: scaleNumberLabel, scaleNumberStyles: itemScaleNumberStyles, priceIntegers: priceIntegers, priceDecimals: priceDecimals, customSokStyles: sokComponents.customSokStyles })) : (
                    // old KESKO implementation
                    react_1.default.createElement(ItemTable_1.default, { product: product, itemsCount: itemsCount, itemImageStyles: itemImageStyles, scaleNumberLabel: scaleNumberLabel, scaleNumberStyles: itemScaleNumberStyles, itemPriceStyles: itemPriceStyles, itemPriceUnitStyles: itemPriceUnitStyles, priceIntegers: priceIntegers, priceDecimals: priceDecimals, hasImage: hasImage })),
                    react_1.default.createElement("div", { style: chain === 'sok'
                            ? priceItemsStyles.barcodeContainerSok
                            : priceItemsStyles.barcodeContainer },
                        react_1.default.createElement(Barcode_1.default, { id: "".concat(id, "-").concat(i, "-productId"), value: productId, options: {
                                format: 'EAN13',
                                lineColor: 'black',
                                displayValue: true,
                                flat: true,
                                width: 1.5,
                                height: 10,
                                margin: 1,
                                fontSize: 18,
                                textMargin: 0
                            } }))))));
    })));
};
exports.default = PriceItems;
//# sourceMappingURL=PriceItems.js.map